// extracted by mini-css-extract-plugin
module.exports = {"list":"Partners_list__3rmym","card":"Partners_card__1Orsy","imagelist":"Partners_imagelist__gVDCB"};